// extracted by mini-css-extract-plugin
module.exports = {"label":"Select_label__2kZV8","select":"Select_select__XOKag","small":"Select_small__XDwdO","medium":"Select_medium__kw5ZW"};